module.exports = __webpack_public_path__ + "img/header.97bf919e.png";